// Interface colours, shadows and radii for Vendia Business, derived only from the
// Brand OS tokens (vendia-brand/tokens, v1.1.0). Components use these instead of
// raw hex values so the app stays inside the brand book:
// - Business purple is the only product colour (green = Quote, blue = POS).
// - Navy/ink/neutral greys carry structure; no gradients, glows or blur.
// - Text meets WCAG AA: secondary text is the token textMuted (#667085, 4.97:1).
// - Status colours are the brand's product-neutral status tokens (success =
//   navy, so always pair it with an icon or label).

import { ACCENT, MASTER, vendiaTokens } from './index';

const STATUS = vendiaTokens.color.status;
const navyAlpha = (alpha: number) => `rgba(0, 18, 61, ${alpha})`;
const accentAlpha = (alpha: number) => `rgba(108, 60, 255, ${alpha})`;

export const UI = {
  accent: ACCENT[600],
  accentSoft: ACCENT[500],
  accentTint: ACCENT[50],
  accentLine: ACCENT[200],
  accentAlpha,
  navy: MASTER.navy,
  ink: MASTER.ink,
  slate: MASTER.slate,
  muted: MASTER.muted,
  surface: MASTER.surface,
  white: MASTER.white,
  text: MASTER.ink,
  textSecondary: vendiaTokens.color.semantic.textMuted,
  border: navyAlpha(0.12),
  borderStrong: navyAlpha(0.2),
  headerFill: navyAlpha(0.03),
  // Status tokens.
  success: STATUS.success,
  successTint: STATUS.successSurface,
  warning: STATUS.warning,
  warningTint: STATUS.warningSurface,
  warningLine: `${STATUS.warning}47`,
  danger: STATUS.danger,
  dangerTint: STATUS.dangerSurface,
  dangerLine: `${STATUS.danger}47`,
  shadowSm: vendiaTokens.shadow.sm,
  shadowMd: vendiaTokens.shadow.md,
  radiusSm: 4,
  radiusMd: 8,
  radiusLg: 12
} as const;

/** Chart series, in order: Business purple, navy, lighter purple, slate grey, amber, red. */
export const CHART_COLORS = [UI.accent, UI.navy, UI.accentSoft, UI.muted, UI.warning, UI.danger, UI.slate, UI.accentLine];

/** Shared axis/grid styling for ApexCharts. */
export const CHART_AXIS = { fontSize: '11px', colors: UI.textSecondary };
export const CHART_GRID = UI.border;
